import React, { useState } from 'react';

/** پرسش‌های متداول — زبان vibefarsi: دو ستونه (مقدمه + آکاردئون)، کارت‌های تم‌محور. */
export default function SectionFaq({ data, settings = {}, embedded }) {
  const faqs = data.faqs || [];
  const [open, setOpen] = useState(0);
  if (!faqs.length) return null;

  const items = (
    <div>
      {faqs.map((f, i) => {
        const isOpen = open === i;
        return (
          <div key={f.id} style={{
            border: 'var(--shape-line) solid var(--border)', borderRadius: 'var(--shape-card)',
            marginBottom: 10, overflow: 'hidden',
            background: isOpen ? 'var(--card)' : 'transparent',
            transition: 'background 0.2s',
          }}>
            <button
              onClick={() => setOpen(isOpen ? -1 : i)}
              aria-expanded={isOpen}
              style={{
                width: '100%', textAlign: 'right', padding: '16px 18px', background: 'none', border: 'none',
                cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12,
                fontWeight: 700, fontSize: '0.95rem', color: 'var(--fg)', fontFamily: 'inherit', lineHeight: 1.8,
              }}>
              {f.question}
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"
                strokeLinecap="round" strokeLinejoin="round" aria-hidden
                style={{ flexShrink: 0, color: 'var(--muted-fg)', transition: 'transform 0.25s', transform: isOpen ? 'rotate(180deg)' : 'none' }}>
                <path d="m6 9 6 6 6-6" />
              </svg>
            </button>
            <div style={{ display: 'grid', gridTemplateRows: isOpen ? '1fr' : '0fr', transition: 'grid-template-rows 0.28s ease' }}>
              <div style={{ overflow: 'hidden' }}>
                <p style={{ padding: '0 18px 18px', margin: 0, color: 'var(--muted-fg)', lineHeight: 2, fontSize: '0.9rem' }}>{f.answer}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );

  const intro = (
    <div>
      <h2 style={{ fontSize: 'clamp(1.5rem, 4vw, 2.1rem)', fontWeight: 800, margin: 0, color: settings.titleColor || 'var(--fg)', lineHeight: 1.5 }}>
        {settings.sectionTitle || settings.title || 'پرسش‌های متداول'}
      </h2>
      <p style={{ marginTop: 12, color: 'var(--muted-fg)', lineHeight: 2, fontSize: '0.95rem', maxWidth: 380 }}>
        {settings.desc || 'اگر جواب‌تان این‌جا نیست، بپرسید؛ معمولاً در یک روز کاری جواب می‌دهیم.'}
      </p>
    </div>
  );

  return (
    <section className={embedded ? undefined : 'container'} style={embedded ? undefined : { padding: 'clamp(48px, 8vw, 88px) 20px' }}>
      <div style={{
        maxWidth: 1024, margin: '0 auto', display: 'grid', gap: 'clamp(24px, 5vw, 48px)',
        gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', alignItems: 'start',
      }}>
        {intro}
        {items}
      </div>
    </section>
  );
}
